// extracted by mini-css-extract-plugin
export default {"anyday":"brand_anyday__75763"};